export const PAGINATION_LIMIT = 25

export const NYC_ORGANIZATION_ID = '6966036a-12d4-4a57-a2ad-c119d797edd1'
export const DRIVERS_UNION_ID = '1f0636ef-588f-4dbd-ab55-114750af7dc2'
export const UNION360 = '6b007544-3832-4a1f-a47a-e07535e3b2ec'

export const ALL_ORGANIZATION_NAMES = [
  'wbf',
  'bcf-new-york',
  'idg-illinois',
  'drivers-union',
  'demonstration-org',
  'drivers-demand-justice',
  'union360',
  'idg-connecticut',
  'idg-florida',
  'idg-state-is-not-listed',
  'idg-machinists-union',
  'idg-new-jersey',
  'benestream',
  'idg-new-york',
]

export const LANGUAGES_FOR_LOCATIONS = [
  { label: 'Arabic', value: 'ar' },
  { label: 'Armenian', value: 'hy' },
  { label: 'Cantonese', value: 'yue' },
  { label: 'Chinese', value: 'zh' },
  { label: 'Creole', value: 'ht' },
  { label: 'Czech', value: 'cs' },
  { label: 'Dutch', value: 'nl' },
  { label: 'English', value: 'en' },
  { label: 'Farsi', value: 'fa' },
  { label: 'Filipino', value: 'fil' },
  { label: 'Finnish', value: 'fi' },
  { label: 'French', value: 'fr' },
  { label: 'German', value: 'de' },
  { label: 'Greek', value: 'el' },
  { label: 'Gujarati', value: 'gu' },
  { label: 'Hebrew', value: 'he' },
  { label: 'Hindi', value: 'hi' },
  { label: 'Ilocano', value: 'ilo' },
  { label: 'Indonesian', value: 'id' },
  { label: 'Italian', value: 'it' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Korean', value: 'ko' },
  { label: 'Kurdish', value: 'ku' },
  { label: 'Mandarin', value: 'zh-CN' },
  { label: 'Marathi', value: 'mr' },
  { label: 'Persian', value: 'fa' },
  { label: 'Polish', value: 'pl' },
  { label: 'Portuguese', value: 'pt' },
  { label: 'Romanian', value: 'ro' },
  { label: 'Russian', value: 'ru' },
  { label: 'Spanish', value: 'es' },
  { label: 'Swedish', value: 'sv' },
  { label: 'Tagalog', value: 'tl' },
  { label: 'Thai', value: 'th' },
  { label: 'Turkish', value: 'tr' },
  { label: 'Ukrainian', value: 'uk' },
  { label: 'Urdu', value: 'ur' },
  { label: 'Vietnamese', value: 'vi' },
  { label: 'Yiddish', value: 'yi' },
]
